import {supabase} from "../../../services/Supabase";

export const ChartingService = {
    get: async function(id: string) {
        let { data, error } = await supabase
            .from('charting')
            .select('*')
            .eq("id", id)
        return data
    },


    view: async function() {
        let { data, error } = await supabase
            .from('charting')
            .select('*')
        return data
    },

    create: async function(chart: any) {
        const { data, error } = await supabase
            .from('charting')
            .insert([
                { id: chart.id },
            ])
        return data
    },

    update: async function(id: string, chart: any) {
        const { data, error } = await supabase
            .from('charting')
            .update([
                { ...chart },
            ])
            .eq('id', id)
        return data
    },

    remove: async function(id: string)  {
        const { data, error } = await supabase
            .from('charting')
            .delete()
            .eq('id', id)
        return data
    }
}